<div
    class="special-comparation-component"
    fxLayout="column"
    fxFlex
    fxLayoutAlign="center none"
>
    @if (isCustomStructure) {
        <div class="special-comparation-component_vertical-line">
            <span class="text-12-semi-bold">{{ getComparationLabel() }}</span>
        </div>
        @for (comparation of comparations(); track $index) {
            <div
                class="special-comparation-component_progress flex-1"
                fxLayout="column"
                fxFlex
            >
                <div
                    class="special-comparation-component_progress-indicator-values"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                >
                    <span class="text-12-semi-bold">{{
                        comparation.serie.props.name
                    }}</span>
                    <app-comparation-percentage-value
                        fxLayout="column"
                        [icon]="comparation.polarityIcon"
                        [tooltip]="comparation.explanationVariation"
                        [polarityColor]="comparation.polarityColor"
                        [percentage]="comparation.valuePercentageCurrencyString"
                    ></app-comparation-percentage-value>
                </div>
                <div class="special-comparation-component_progress-bar">
                    <dsn-progress-bar
                        [value]="comparation.progress"
                        [max]="100"
                        [customColor]="comparation.polarityColorByConfig"
                        [marker]="false"
                        [divider]="[]"
                    ></dsn-progress-bar>
                </div>

                <div
                    class="special-comparation-component_progress-indicator-values"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                >
                    <span class="text-12-semi-bold info">{{
                        comparation.currencyString
                    }}</span>
                    <app-comparation-percentage-value
                        fxLayout="column"
                        [tooltip]="comparation.explanationVariation"
                        [icon]="comparation.polarityIcon"
                        [polarityColor]="comparation.polarityColor"
                        [percentage]="comparation.percentageLocaleString"
                    ></app-comparation-percentage-value>
                </div>
            </div>
        }
    } @else {
        <app-highcharts-render
            class="full-height"
            [options]="options"
            [visualization]="visualization"
            [series]="series"
            [points]="points"
            [company]="company"
        ></app-highcharts-render>
    }
</div>
